// src/pages/Trend/components/analysis/market-trends/ChartContainer.js
import React from 'react';
import { BOLSTER_COLORS } from '../common/BolsterColors';
import { BBC_STYLE } from '../../../../../styles/chartStyles';

/**
 * Reusable container component for metric charts
 * Provides consistent styling, shadows, and hover effects across all charts
 */
const ChartContainer = ({ children, style = {}, autoHeight = false, height = '464.233px' }) => {
  const handleMouseEnter = (e) => {
    e.currentTarget.style.transform = 'translateY(-2px)';
    e.currentTarget.style.boxShadow = '0 2px 8px rgba(0, 0, 0, 0.1)';
  };

  const handleMouseLeave = (e) => {
    e.currentTarget.style.transform = 'translateY(0)';
    e.currentTarget.style.boxShadow = '0 1px 3px rgba(0, 0, 0, 0.08)';
  };

  return (
    <div
      style={{
        fontFamily: BBC_STYLE.FONT_FAMILY,
        background: BOLSTER_COLORS.BG_WHITE,
        border: `1px solid ${BOLSTER_COLORS.BORDER}`,
        borderRadius: '12px',
        padding: '20px',
        ...(autoHeight ? { minHeight: 'auto' } : { height }),
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'column',
        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.08)',
        transition: 'transform 0.2s ease, box-shadow 0.2s ease',
        cursor: 'default',
        overflow: 'hidden',
        ...style
      }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {children}
    </div>
  );
};

export default ChartContainer;
